import { Link } from "react-router-dom";
import Seo, { breadcrumbSchema } from "@/components/Seo";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";
import { Overline } from "@/components/Btn";
import { Breadcrumb } from "@/components/Breadcrumb";
import { CtaBand } from "@/components/CtaBand";
import { REALISATIONS } from "@/data/realisations";

export default function Realisations() {
  const crumbs = [
    { label: "Accueil", to: "/" },
    { label: "Réalisations", to: "/realisations/" },
  ];
  return (
    <>
      <Seo
        title="Réalisations d'enseignes lumineuses & signalétique | Ronalp Enseigne"
        description="Découvrez nos réalisations d'enseignes lumineuses, lettres boîtiers, totems et signalétique à Genève, Lausanne, Annecy, Lyon et dans le Pays de Gex."
        path="/realisations/"
        jsonLd={[breadcrumbSchema(crumbs)]}
      />
      <section className="relative overflow-hidden border-b border-white/10">
        <div className="absolute inset-0 -z-10 bg-grid bg-grid-fade opacity-30" />
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10 lg:py-16">
          <Breadcrumb items={crumbs} />
          <Reveal className="mt-8 max-w-3xl">
            <Overline>Nos réalisations</Overline>
            <h1 className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase tracking-tight text-white leading-[0.98]">Portfolio de chantiers</h1>
            <p className="mt-5 text-lg text-slate-300">Enseignes lumineuses, totems, habillages de façade et marquage : des projets menés de la conception à la pose, en France et en Suisse.</p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <Stagger className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {REALISATIONS.map((r) => (
            <StaggerItem key={r.slug}>
              <Link to={`/realisations/${r.slug}/`} className="group block h-full overflow-hidden rounded-xl border border-white/10 bg-ink-800 hover:shadow-2xl hover:shadow-signature/10 transition-all" data-testid={`realisation-${r.slug}`}>
                <div className="relative h-56 overflow-hidden">
                  <img src={r.cover} alt={r.alt} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink-900/90 to-transparent" />
                  <span className="absolute bottom-4 left-4 rounded-full bg-ink-900/80 px-3 py-1 text-xs font-mono uppercase tracking-wider text-signature border border-signature/30">{r.city}</span>
                </div>
                <div className="p-6">
                  <p className="text-xs font-mono uppercase tracking-wider text-chrome-mid">{r.type}</p>
                  <h2 className="mt-2 text-lg font-semibold text-white group-hover:text-signature transition-colors line-clamp-2">{r.title}</h2>
                </div>
              </Link>
            </StaggerItem>
          ))}
        </Stagger>
      </section>

      <CtaBand />
    </>
  );
}
